import Blue from "~/core";

new Blue({
	name: 'Header Mobile Nav Menu',
	selector: ".header",
	setup(header) {
		const search = header.querySelector("form.header__toolbar-search");
		const searchInput = search.querySelector("input.header__toolbar-input");
		const toolbarNav = header.querySelector(".header__toolbar-nav");
		const mainNav = header.querySelector("nav.header__nav");
		const drawer = header.querySelector(".header__mobile-drawer");
		const largeBreakpoint = 992;
		const primaryItems = [...header.querySelectorAll("li.header__primary-item")];
		const secondaryItems = [...header.querySelectorAll("li.header__secondary-item")];
		const lastMobileNavLink = header.querySelector(".header__toolbar-item:last-child .header__toolbar-link"); // Used for trapping focus
		let accordionArray = [];
		const mobileMenuToggle = header.querySelector("button.header__mobile-toggle");
		let accordionsInitiated = false;

		const setMobileDrawerHeight = () => {
			let windowHeight = window.innerHeight;
			drawer.style.maxHeight = windowHeight - drawer.getBoundingClientRect().top + "px";
		}

		const toggleMobileMenu = () => {
			header.classList.toggle("is-open");
			let mobileMenuSelector = document.querySelector("#mobile-menu");
			if (header.matches(".is-open")) {
				setMobileDrawerHeight();
				this.$scrollLock.lock(mobileMenuSelector); //this will disable body scroll while enabling scroll on target(mobileMenuSelector) element
				mobileMenuToggle.setAttribute("aria-expanded", "true");
			} else {
				this.$scrollLock.unlock(mobileMenuSelector); //Enables body scroll and removing listeners on target(mobileMenuSelector) element
				mobileMenuToggle.setAttribute("aria-expanded", "false");
				accordionArray.forEach(t => t.close());
			}
		}

		this.$addEvents(mobileMenuToggle, "click", toggleMobileMenu)

		const initToggle = (itemArray, toggleSelector, listSelector) => {
			let relations = [];
			itemArray.forEach(container => {
				let trigger = container.querySelector(toggleSelector) || false;
				let content = container.querySelector(listSelector) || false;
				let necessaryParentSelector = "#mobile-menu";
				if (trigger && content) {
					let config = {
						container,
						trigger,
						content,
						necessaryParentSelector,
						relations
					}
					let t = new this.$toggle(config);
					accordionArray.push(t);
					relations.push(t);
				}
			});
		}

		const retachSetup = (el) => {
			this.$retach(el, {
				destination: drawer,
				mediaQuery: largeBreakpoint,
				movedClass: 'mobile-view',
				moveMethod: 'append',
				callback_move() {
					searchInput.setAttribute("placeholder", "Search Ferrellgas.com");
					drawer.setAttribute("aria-label", "main");
					if (!accordionsInitiated) {
						initToggle(primaryItems, 'button.header__primary-toggle', 'ul.header__secondary-list');
						initToggle(secondaryItems, 'button.header__secondary-toggle', 'ul.header__tertiary-list');
						accordionsInitiated = true;
					}
				},
				callback_back() {
					searchInput.setAttribute("placeholder", "Search");
					drawer.setAttribute("aria-label", "");
				}
			});
		}

		// Escape key closes mobile flyout menu when open for accessibility
		this.$addEvents(document.body, "escape", () => {
			if (header.matches(".is-open")) toggleMobileMenu();
		});

		// Main click closes mobile flyout menu when open for accessibility
		this.$addEvents("main", "click", () => {
			if (header.matches(".is-open")) toggleMobileMenu();
		});

		// Done in the order below to match designs and not rely on flex order or something like that
		retachSetup(search);
		retachSetup(mainNav);
		retachSetup(toolbarNav);

    //remove the display attribute for the mainNav (as it was set to none earlier)
    mainNav.style.removeProperty("display");

		// Trap focus inside header
		this.$addEvents(lastMobileNavLink, "blur", () => {
			if (!toolbarNav.matches("*:focus-within")) mobileMenuToggle.focus();
		});

		// If changing screen size between mobile/desktop, close mobile menu and all accordions/close all dropdowns
		let screenWidth = window.innerWidth;
		const closeAllMenus = () => {
			header.classList.remove("is-open");
			accordionArray.forEach(t => t.close());
			[...header.querySelectorAll(".header__primary-item.is-open")]
				.forEach(li => li.classList.remove("is-open"));
		}

		const thresholdCrossed = (formerScreenWidth) => {
			screenWidth = window.innerWidth;
			return (formerScreenWidth < largeBreakpoint && screenWidth >= largeBreakpoint)
				|| (formerScreenWidth >= largeBreakpoint && screenWidth < largeBreakpoint);
		}

		this.$addEvents(window, "resize", () => {
			if (thresholdCrossed(screenWidth)) {
				closeAllMenus();
			}
		})

	}
});

new Blue({
	name: 'Header Desktop Nav Menu',
	selector: ".header",
	setup(header) {
		const primaryItems = [...header.querySelectorAll("li.header__primary-item")];
		const largeBreakpoint = 992;

		const animateList = (list, start, end) => {
			list.animate([
				{ height: `${start}px` },
				{ height: `${end}px` }
			], {
				duration: 150,
				easing: 'ease'
			});
		}

		const openDropdown = (item, list, link, isOpen) => {
			if (window.innerWidth >= largeBreakpoint) {
				if (isOpen) return;
				const start = list.offsetHeight;
				if ([item, list, link].some(t => t.matches("*:hover")) || item.matches("*:focus-within")) item.classList.add("is-open");
				const end = list.offsetHeight;
				animateList(list, start, end);
			}
		}

		const closeDropdown = (item, list, link, isOpen) => {
			if (window.innerWidth >= largeBreakpoint) {
				if (!isOpen) return;
				const start = list.offsetHeight;
				// making sure no part of dropdown is currently hovered or focused on before removing open class
				if ([item, list, link].every(t => !t.matches("*:hover")) && !list.matches("*:focus-within")) item.classList.remove("is-open");
				const end = list.offsetHeight;
				animateList(list, start, end);
			}
		}

		primaryItems.forEach((item, i) => {
			const list = item.querySelector(("ul.header__secondary-list"));
			const innerLinks = [...list.querySelectorAll("a[class]")];
			const link = item.querySelector("a.header__primary-link");
			const toggle = item.querySelector("button.header__primary-toggle")
			let isOpen = false;
			this.$addEvents(item, "mouseover", () => {
				openDropdown(item, list, link, isOpen);
				isOpen = true;
			});
			this.$addEvents(item, "mouseleave", () => {
				closeDropdown(item, list, link, isOpen);
				isOpen = false;
			});
			this.$addEvents(toggle, "enter.prevent", () => {
				if (isOpen) {
					closeDropdown(item, list, link, isOpen);
				} else {
					openDropdown(item, list, link, isOpen);
				}
				isOpen = !isOpen;
			});
			this.$addEvents(innerLinks[innerLinks.length - 1], "focusout", () => {
				closeDropdown(item, list, link, isOpen);
				isOpen = false;
			});
			this.$addEvents(link, "focusout", () => {
				closeDropdown(item, list, link, isOpen);
				isOpen = false;
			});
			this.$addEvents(document, "click", (e) => {
				if (!e.target.closest(".header__primary-item.is-open")) {
					closeDropdown(item, list, link, isOpen);
					isOpen = false;
				}
			});
		});
	}
});

new Blue({
	name: 'Header Search Toggling',
	selector: "form.header__toolbar-search",
	setup(search) {
		const label = search.querySelector("label.header__toolbar-label");
		const focusableFormElements = [...search.querySelectorAll("label, input, button")];
		label.setAttribute("tabindex", "0");
		const toggleSearch = () => {
			search.classList.toggle("is-open")
		}
		this.$addEvents(label, "click enter", toggleSearch);
		focusableFormElements.forEach(el => {
			this.$addEvents(el, "blur", () => {
				if (search.matches(".is-open") && !search.matches(":focus-within")) toggleSearch();
			});
		})
	}
});

new Blue({
	name: 'Header Search Submit',
	selector: "form.header__toolbar-search",
	setup(search) {
		const input = search.querySelector("input.header__toolbar-input");
		const submitHandler = () => {
			let val = input.value;
			let path = search.getAttribute("data-search-page-path");
			if (!!val) {
				if (!!path) {
					path += `/?search=${encodeURIComponent(val)}`;
					window.location = path;
				}
			}
		}

		// use .prevent and preventDefault for added consistency (have seen failures in the past when only using .prevent)
		this.$addEvents(search, "submit.prevent", (e) => {
			e.preventDefault();
			submitHandler();
		});

		this.$addEvents(input, "invalid", (e) => {
			e.preventDefault();
			search.classList.add("submit-attempted")
		});
	}
});